import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";

const roleValidationSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup
      .string()
      .required("This field is required")
      .min(2, t("validations.min_length", { count: 2 }))
      .max(120, t("validations.max_length", { count: 120 })),
    actions: yup
      .array()
      .of(yup.string().required())
      .min(1, "Select at least one action")
      .required("This field is required")
      .default([]),
    status: yup
      .string()
      .oneOf(["ACTIVE", "INACTIVE"], "Invalid status")
      .default("ACTIVE"),
    type: yup
      .string()
      .oneOf(
        ["STANDARD_SYSTEM_ROLE", "STANDARD_ACCOUNT_ROLE", "CUSTOM_ROLE", ""],
        "Invalid type"
      )
      .default(""),
    subType: yup
      .string()
      .oneOf(
        ["IN-HOUSE_PROVIDER", "SUPPORT_STAFF", "OFFICER", ""],
        "Invalid sub type"
      )
      .default(""),
  });

export type RoleFormData = InferType<ReturnType<typeof roleValidationSchema>>;

export default roleValidationSchema;
